<div class="container">
  <!-- Dropdown Filters -->
  <div class="text-center">
    <strong class="mainHeading">Requestor</strong>
  </div>

  <div class="row mt-3 g-3">
    <!-- User Type Filter -->
    <div class="col-12 col-sm-6 col-md-3">
      <label for="typeOfUser" class="form-label">Requestor Type</label>
      <select id="typeOfUser" class="form-select" (change)="filterGrid()">
        <option value="all">All</option>
        <option *ngFor="let type of userType" [value]="type">{{ type }}</option>
      </select>
    </div>

    <!-- City Filter -->
    <div class="col-12 col-sm-6 col-md-3">
      <label for="selectCity" class="form-label">Select City</label>
      <select id="selectCity" class="form-select" (change)="filterGrid()">
        <option value="all">All</option>
        <option *ngFor="let city of cities" [value]="city">{{ city }}</option>
      </select>
    </div>

    <!-- Zone Filter -->
    <div class="col-12 col-sm-6 col-md-3">
      <label for="selectZone" class="form-label">Select Zone</label>
      <select id="selectZone" class="form-select" (change)="filterGrid()">
        <option value="all">All</option>
        <option *ngFor="let zone of zones" [value]="zone">{{ zone }}</option>
      </select>
    </div>

    <!-- Status Filter -->
    <!-- <div class="col-12 col-sm-6 col-md-3">
      <label for="selectStatus" class="form-label">Status</label>
      <select id="selectStatus" class="form-select" (change)="filterGrid()">
        <option value="all">All</option>
        <option *ngFor="let status of userApprovalstatus" [value]="status">{{ status }}</option>
      </select>
    </div> -->
  </div>

  <div class="row d-flex justify-content-around">
    <div class="col-md-3">
      <div
        class="card shadow-sm dashboard-card"
        style="background-color: #f8ecc8"
      >
        <div
          class="card-body d-flex flex-column justify-content-between"
          style="height: 150px"
        >
          <div class="d-flex white">
            <i
              class="bi bi-person-lines-fill fa-2x me-3 empPermission"
              style="color: #ad870c !important"
            ></i>
            <div class="ms-auto text-end">
              <h3 class="card-title mb-0 text-center empPermission">
                {{ cardData?.overallUsersCount }}
              </h3>
            </div>
          </div>
          <div class="text-center">
            <p class="card-text empPermission">Total Users</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card shadow-sm dashboard-card" style="background: #dcffddf7">
        <div
          class="card-body d-flex flex-column justify-content-between"
          style="height: 150px"
        >
          <div class="d-flex white">
            <i
              class="bi bi-person-check fa-2x me-3 empPresent"
              style="color: #2d702f !important"
            ></i>
            <div class="ms-auto text-end">
              <h3 class="card-title mb-0 text-center empPresent">
                {{ cardData?.activeUsersCount }}
              </h3>
            </div>
          </div>
          <div class="text-center">
            <p class="card-text empPresent">Active Users</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div
        class="card shadow-sm dashboard-card"
        style="background-color: #f8d7e5"
      >
        <div
          class="card-body d-flex flex-column justify-content-between"
          style="height: 150px"
        >
          <div class="d-flex white">
            <i
              class="bi bi-person-slash fa-2x me-3 totalEmployees"
              style="color: #9b1b30 !important"
            ></i>
            <div class="ms-auto text-end">
              <h3 class="card-title mb-0 text-center totalEmployees">
                {{ cardData?.inActiveUserCount }}
              </h3>
            </div>
          </div>
          <div class="text-center">
            <p class="card-text totalEmployees">Inactive Users</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center">
    <div class="d-flex">
      <button
        class="btn btn-outline-secondary"
        type="button"
        ngbTooltip="Export"
        (click)="exportToExcel()"
      >
        <span><i class="bi bi-box-arrow-up me-2"></i></span>
        Export
      </button>
      <button
        class="btn btn-outline-secondary ms-2"
        type="button"
        ngbTooltip="Print"
        (click)="exportToPDF()"
      >
        <span><i class="bi bi-printer me-2"></i></span>
        Print
      </button>
      <button
        class="btn btn-outline-secondary ms-2"
        type="button"
        (click)="clearFilter()"
        ngbTooltip="Clear Filter"
      >
        <span><i class="bi bi-x-circle me-2"></i></span>
        Clear Filter
      </button>
    </div>
    <div class="ms-auto col-md-3 col-sm-6">
      <input
        type="text"
        class="form-control"
        placeholder="Search..."
        (input)="OnSearch($event)"
      />
    </div>
  </div>

  <!-- Data Grid -->
  <div class="card shadow-lg p-3 mt-2">
    <!-- <div class="custom-modal-header">
        <h2 class="text-center mt-2">Requestor List</h2>
      </div> -->

    <div class="table-responsive">
      <table class="table table-bordered">
        <thead class="text-center">
          <tr>
            <!-- <th>S.No</th> -->
            <!-- <th>User ID</th> -->
            <th>Requestor Company Name</th>
            <th>Mobile No</th>
            <th>Requestor</th>
            <th>City</th>
            <th>Zone</th>
            <th>Date Registered</th>
            <th>CR Number</th>
            <th>VAT Number</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let user of pagedData; let i = index">
            <!-- <td class="text-center">{{ i + 1 }}</td> -->
            <!-- <td class="text-center">{{ user.userId }}</td> -->
            <td class="text-center">
              {{ user.userType === "1" ? user.userName : user.companyName }}
            </td>
            <td class="text-center">{{ user.phNo }}</td>
            <td class="text-center">{{ changeUserType(user.userType) }}</td>
            <td class="text-center">{{ user.cityName }}</td>
            <td class="text-center">{{ user.zoneName }}</td>
            <td class="text-center">
              {{ user.createdDate | date : "dd MMM yyyy" }}
            </td>
            <td class="text-center">
              {{ user.userType === "2" ? user.crNumber : "N/A" }}
            </td>
            <td class="text-center">
              {{ user.userType === "2" ? user.vatNumber : "N/A" }}
            </td>
            <!-- <td class="text-center">{{ user.userStatus }}</td> -->
            <!-- <td (click)="openChangeStatusPopup(openmodel, user)" class="text-center"
              [ngClass]="{ 'disabled-cell': user.userApprovalstatus === null && user.userType == 2 }">
              <a [ngClass]="{
                  'text-success': user.isActive === true,
                  'text-danger': user.isActive === false
                }" class="hyperLink">
                {{ getStatus(user.isActive) }}
              </a>
            </td> -->
            <td
              class="text-center"
              [ngClass]="{
                'disabled-cell':
                  user.userApprovalstatus === null && user.userType == 2
              }"
            >
              <p
                [ngClass]="{
                  'text-success': user.isActive === true,
                  'text-danger': user.isActive === false
                }"
              >
                {{ getStatus(user.isActive) }}
              </p>
            </td>
            <td class="text-center">
              <div
                (click)="
                  user.userType === '2' &&
                    openDownloadDocumentsModal(user, downloadDocumentsModal)
                "
              >
                <i
                  *ngIf="user.userType === '2'"
                  class="ms-3 fas fa-download"
                ></i>
                <span *ngIf="user.userType !== '2'">-</span>
              </div>
            </td>
          </tr>
          <tr *ngIf="requestorsData?.length === 0">
            <td colspan="11" class="text-center">No Data Found</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <!-- Pagination Centered -->
      <div class="d-flex justify-content-center flex-grow-1">
        <ngb-pagination
          *ngIf="requestorsData?.length > 0"
          [(page)]="page"
          [pageSize]="pageSize"
          [collectionSize]="requestorsData?.length"
          (pageChange)="onPageChange($event)"
          [boundaryLinks]="true"
        >
        </ngb-pagination>
      </div>

      <!-- Entries Message Aligned to the End -->
      <div *ngIf="requestorsData?.length > 0" class="text-muted mb-3">
        <strong
          >Showing {{ (page - 1) * pageSize + 1 }} to
          {{
            page * pageSize > requestorsData?.length
              ? requestorsData?.length
              : page * pageSize
          }}
          of {{ requestorsData?.length }} entries</strong
        >
      </div>
    </div>
  </div>
</div>

<!-- Change Status Modal -->
<ng-template #openmodel let-modal>
  <div class="modal-header">
    <h2 class="modal-title mt-2">Change Status</h2>
    <button
      type="button"
      class="btn-close"
      style="background-color: white !important"
      aria-label="Close"
      (click)="modal.dismiss()"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      Do you want to change the status to
      <strong>{{
        currentCityForStatusChange?.isActive === true ? "Inactive" : "Active"
      }}</strong
      >?
    </p>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button class="btn btn-primary" (click)="changeCityStatus(modal)">
      Confirm
    </button>
  </div>
</ng-template>

<ng-template #downloadDocumentsModal let-modal>
  <div class="modal-header">
    <h3 class="modal-title mt-3">Download CR/VAT</h3>
    <button
      type="button"
      class="btn-close"
      style="background-color: white !important"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body custom-modal">
    <p>Choose the document type:</p>

    <button
      type="button"
      class="btn btn-primary mt-3 mb-2"
      (click)="downloadCrVatDocument('CR')"
    >
      Download CR
    </button>
    &nbsp;
    <button
      type="button"
      class="btn btn-primary mt-3 mb-2"
      (click)="downloadCrVatDocument('VAT')"
    >
      Download VAT
    </button>
  </div>
</ng-template>
